import * as S from '@effect/schema/Schema';
const Spaces = S.Struct({
    spaces: S.Array(S.String),
});
/**
 * Takes over from the io-ts equivalent. Please migrate as it becomes possible
 *
 * Collects option values per name.
 */
const Options = S.Struct({
    properties: S.Record({
        key: S.String,
        value: S.Array(S.Union(S.String, S.Number, S.Null)), // e.g. "Basin:Product": ["AZ1012M", "AZ1020", "AZ103"]
    }),
});
export const decodeSpaces = S.decodeUnknownSync(Spaces);
export const decodeOptions = S.decodeUnknownSync(Options);
